package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /chat route — redirects to /inbox?tab=chats.
 *
 * Content has fully moved to the «Чаты» tab of InboxPage (R7).
 * This stub keeps old bookmarks and external links working.
 *
 * URL param mapping:
 *   ?scope=… → forwarded as ?scope=…   (MY/ALL scope toggle)
 *   ?page=…  → forwarded as ?page=…    (page number)
 *   ?q=…     → forwarded as ?q=…       (search query)
 */
@Page("/chat")
@Composable
fun ChatPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val params = buildString {
            val scope = urlParam("scope")?.ifBlank { null }
            val page = urlParam("page")?.ifBlank { null }
            val q = urlParam("q")?.ifBlank { null }
            if (scope != null) append("&scope=${encodeQueryValue(scope)}")
            if (page != null) append("&page=${encodeQueryValue(page)}")
            if (q != null) append("&q=${encodeQueryValue(q)}")
        }
        ctx.router.navigateTo("${Routes.INBOX}?tab=chats$params")
    }
}
